import { render } from "./gradesheet.vue?vue&type=template&id=318c4436"
import script from "./gradesheet.vue?vue&type=script&lang=js"
export * from "./gradesheet.vue?vue&type=script&lang=js"

import "./gradesheet.vue?vue&type=style&index=0&id=318c4436&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__